
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research/author/[...slug]",
      function () {
        return require("private-next-pages/research/author/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research/author/[...slug]"])
      });
    }
  